/* ──────────────────────────────────────────────────────────────────────────
 *  GA4 adapter — maps AnalyticsAdapter.track() to window.gtag("event",…)
 * ────────────────────────────────────────────────────────────────────────── */

import type {
  AnalyticsAdapter,
  AnalyticsEventName,
  AnalyticsEventMap,
} from "../types";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: Record<string, unknown>[];
  }
}

const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? "";

function gtag(...args: unknown[]) {
  window.gtag?.(...args);
}

export const ga4Adapter: AnalyticsAdapter = {
  name: "ga4",

  init() {
    if (!GA_ID || typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ??
      function gtagFn() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer!.push(arguments as unknown as Record<string, unknown>);
      };
    gtag("js", new Date());
    gtag("config", GA_ID, { send_page_view: false });
  },

  track<E extends AnalyticsEventName>(
    event: E,
    properties: AnalyticsEventMap[E],
  ) {
    if (!GA_ID) return;
    gtag("event", event, properties);
  },

  identify(userId: string) {
    if (!GA_ID) return;
    gtag("config", GA_ID, { user_id: userId });
  },

  reset() {
    if (!GA_ID) return;
    gtag("config", GA_ID, { user_id: undefined });
  },
};
